import React from 'react';
import Modal from 'SharedComponents/Modal';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styles from './ConnectionDownModal.module.css';
import Button from 'SharedComponents/Button';

import fix from 'images/fix.png';

ConnectionDownModal.propTypes = {
  isShowing: PropTypes.bool,
  onHide: PropTypes.func
};

function ConnectionDownModal(props) {
  const { isShowing, onHide } = props;
  const { t } = useTranslation('termLife');

  const renderContent = () => {
    return (
      <Row>
        <Col>{t('global.modal.connection_down.desc')}</Col>
      </Row>
    );
  };

  const renderFooter = () => {
    const okayBtnProps = {
      isDisabled: false,
      onClick: onHide
    };

    return (
      <>
        <Row className={styles.okayBtn}>
          <Col>
            <Button {...okayBtnProps}>{t('button.okay')}</Button>
          </Col>
        </Row>
      </>
    );
  };

  const modalProps = {
    isShowing,
    onHide,
    title: t('global.modal.connection_down.title'),
    headerIcon: fix,
    content: renderContent(),
    footer: renderFooter()
  };

  return <Modal {...modalProps} />;
}

export default ConnectionDownModal;
